import { Box, Typography } from "@material-ui/core";
import * as React from "react";

import { CustomButton } from "@/components/Button";

export const PROPOSAL_LOAD_ERROR_TITLE = "メッセージを取得できませんでした";

export const ProposalLoadError: React.FC<{ onRetry: () => void; compact?: boolean }> = ({ onRetry, compact }) => (
  <Box role="alert" p={compact ? 2 : 4} textAlign="center">
    <Typography variant="h4">{PROPOSAL_LOAD_ERROR_TITLE}</Typography>
    <Box my={2}>
      <Typography variant="body2">通信状況を確認し、もう一度お試しください。</Typography>
      {compact && <Typography variant="body2">前回取得した内容を表示しています。</Typography>}
    </Box>
    <CustomButton customVariant="filled" onClick={onRetry}>再試行</CustomButton>
  </Box>
);
